import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Spin, InputNumber } from "antd";
import React, { useState, useEffect } from "react";
import EditUserApi from "../../../api/users/EditUserApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import PhrmService from "../../../services/PhrmService";

function EditUserModal(props) {
  const [submit, setSubmit] = useState(false);
  const [valuesChanged, setValuesChanged] = useState(false);
  const [isPhrmEnabled, setIsPhrmEnabled] = useState(false);

  useEffect(() => {
    checkPhrmPermissions();
  }, [props.visible]);

  async function checkPhrmPermissions() {
    const phrmEnabled = await PhrmService.isPhrmEnabled();
    setIsPhrmEnabled(phrmEnabled);
  }

  async function onFinish(values) {
    setSubmit(true);

    const apiResponse = await EditUserApi(
      props.user?.id,
      values.email,
      values.employeeId,
      values.hourlyRate,
      values.empReferrenceId,
      values.whatsappNumber
    );

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "User added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add user try again later."
      );
    }
    setSubmit(false);
    setValuesChanged(false);

    props.handleCancel();
  }

  return (
    <Modal
      title="Edit user"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addUser"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        initialValues={{
          email: props.user?.email,
          employeeId: props.user?.employeeId,
          hourlyRate: props.user?.hourlyRate,
          empReferrenceId: props.user?.empReferrenceId,
          whatsappNumber: props.user?.whatsappNumber,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Employee Id" name="employeeId">
          <Input placeholder="Employee Id" />
        </Form.Item>

        <Form.Item
          label="Email*"
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter an email!",
            },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>

        <Form.Item label="Hourly Rate ($)" name="hourlyRate">
          <InputNumber
            placeholder="0.00"
            min={0}
            precision={2}
            style={{ width: '100%' }}
            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>

        {isPhrmEnabled && (
          <Form.Item label="Employee Reference ID" name="empReferrenceId">
            <Input placeholder="e.g., 000001" maxLength={50} />
          </Form.Item>
        )}

        <Form.Item label="WhatsApp Number" name="whatsappNumber" extra="Include country code, e.g. +94771234567">
          <Input placeholder="+94771234567" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditUserModal;
